var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"dense":"","disabled":_vm.disabled,"readonly":_vm.readonly,"label":_vm.label,"rules":_vm.rules,"items":_vm.listData,"item-text":"description","item-value":"id","required":_vm.required},on:{"change":_vm.onSelect},model:{value:(_vm.dataType),callback:function ($$v) {_vm.dataType=$$v},expression:"dataType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }